(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-overlay-only"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const logoSection = document.getElementById('logoOverlayContainer');

    function handleScroll() {
      const rect = logoSection.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;
      logoSection.classList.toggle('visible', inView);
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // run on load
  });

  } catch(e) { console.error(e); }
})();
})();
